import { render, staticRenderFns } from "./camera-field.vue?vue&type=template&id=a2a9f3ec&scoped=true"
import script from "./camera-field.vue?vue&type=script&lang=js"
export * from "./camera-field.vue?vue&type=script&lang=js"
import style0 from "./camera-field.vue?vue&type=style&index=0&id=a2a9f3ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a9f3ec",
  null
  
)

export default component.exports